var $7d85f4634d55e2f9$exports = {};
const $7d85f4634d55e2f9$var$STORAGE_KEY = "composition-boxes-per-line";
const $7d85f4634d55e2f9$var$PREVIEW_FONT_KEY = "composition-preview-font";
const $7d85f4634d55e2f9$var$DEFAULT_BOXES_PER_LINE = 15;
const $7d85f4634d55e2f9$var$MIN_BOXES_PER_LINE = 1;
const $7d85f4634d55e2f9$var$MAX_BOXES_PER_LINE = 50;
const $7d85f4634d55e2f9$var$PERFORMANCE_WARNING_THRESHOLD = 1000;
const $7d85f4634d55e2f9$var$DEFAULT_PREVIEW_FONT = "default";
const $7d85f4634d55e2f9$var$PREVIEW_FONT_CLASSES = {
    default: null,
    "klee-one": "preview--klee-one",
    yomogi: "preview--yomogi",
    "yuji-boku": "preview--yuji-boku",
    "hachi-maru-pop": "preview--hachi-maru-pop"
};
const $7d85f4634d55e2f9$var$textareaElement = document.getElementById("composition-text");
const $7d85f4634d55e2f9$var$boxesPerLineElement = document.getElementById("boxes-per-line");
const $7d85f4634d55e2f9$var$previewFontElement = document.getElementById("preview-font");
const $7d85f4634d55e2f9$var$previewPanelElement = document.querySelector(".preview-panel");
const $7d85f4634d55e2f9$var$previewElement = document.getElementById("preview");
const $7d85f4634d55e2f9$var$characterCountElement = document.getElementById("character-count");
const $7d85f4634d55e2f9$var$characterWarningElement = document.getElementById("character-warning");
const $7d85f4634d55e2f9$var$printPreviewButtonElement = document.getElementById("print-preview");
const $7d85f4634d55e2f9$var$state = {
    text: $7d85f4634d55e2f9$var$textareaElement.value,
    boxesPerLine: $7d85f4634d55e2f9$var$getStoredBoxesPerLine(),
    previewFont: $7d85f4634d55e2f9$var$getStoredPreviewFont()
};
$7d85f4634d55e2f9$var$boxesPerLineElement.value = String($7d85f4634d55e2f9$var$state.boxesPerLine);
$7d85f4634d55e2f9$var$previewFontElement.value = $7d85f4634d55e2f9$var$state.previewFont;
$7d85f4634d55e2f9$var$previewElement.style.setProperty("--boxes-per-line", String($7d85f4634d55e2f9$var$state.boxesPerLine));
$7d85f4634d55e2f9$var$applyPreviewFontClass($7d85f4634d55e2f9$var$state.previewFont);
function $7d85f4634d55e2f9$var$getStoredBoxesPerLine() {
    try {
        const storedValue = localStorage.getItem($7d85f4634d55e2f9$var$STORAGE_KEY);
        if (!storedValue) return $7d85f4634d55e2f9$var$DEFAULT_BOXES_PER_LINE;
        return $7d85f4634d55e2f9$var$clampBoxesPerLine(Number.parseInt(storedValue, 10));
    } catch  {
        return $7d85f4634d55e2f9$var$DEFAULT_BOXES_PER_LINE;
    }
}
function $7d85f4634d55e2f9$var$clampBoxesPerLine(value) {
    if (!Number.isFinite(value)) return $7d85f4634d55e2f9$var$DEFAULT_BOXES_PER_LINE;
    return Math.min($7d85f4634d55e2f9$var$MAX_BOXES_PER_LINE, Math.max($7d85f4634d55e2f9$var$MIN_BOXES_PER_LINE, value));
}
function $7d85f4634d55e2f9$var$persistBoxesPerLine(value) {
    try {
        localStorage.setItem($7d85f4634d55e2f9$var$STORAGE_KEY, String(value));
    } catch  {
    // Ignore storage failures.
    }
}
function $7d85f4634d55e2f9$var$getStoredPreviewFont() {
    try {
        const storedValue = localStorage.getItem($7d85f4634d55e2f9$var$PREVIEW_FONT_KEY);
        if (storedValue === "default" || storedValue === "klee-one" || storedValue === "yomogi" || storedValue === "yuji-boku" || storedValue === "hachi-maru-pop") return storedValue;
    } catch  {
    // Ignore storage failures.
    }
    return $7d85f4634d55e2f9$var$DEFAULT_PREVIEW_FONT;
}
function $7d85f4634d55e2f9$var$persistPreviewFont(value) {
    try {
        localStorage.setItem($7d85f4634d55e2f9$var$PREVIEW_FONT_KEY, value);
    } catch  {
    // Ignore storage failures.
    }
}
function $7d85f4634d55e2f9$var$applyPreviewFontClass(selectedFont) {
    for (const className of Object.values($7d85f4634d55e2f9$var$PREVIEW_FONT_CLASSES))if (className) $7d85f4634d55e2f9$var$previewElement.classList.remove(className);
    const nextClass = $7d85f4634d55e2f9$var$PREVIEW_FONT_CLASSES[selectedFont];
    if (nextClass) $7d85f4634d55e2f9$var$previewElement.classList.add(nextClass);
}
function $7d85f4634d55e2f9$var$sanitizeInputText(text) {
    return text.replace(/[ \t\u3000]/g, "");
}
function $7d85f4634d55e2f9$var$isPunctuationChar(char) {
    return /[\p{P}\p{S}]/u.test(char);
}
function $7d85f4634d55e2f9$var$applyParagraphRules(line, boxesPerLine) {
    if (line.length === 0) return [];
    const chars = line.split("");
    // Add one leading empty box for new paragraphs unless punctuation starts it.
    if (!$7d85f4634d55e2f9$var$isPunctuationChar(chars[0])) chars.unshift("");
    // If non-punctuation content lands exactly at row end, fold trailing punctuation
    // into the final non-empty box on that row.
    const trailingPunctuation = [];
    while(chars.length > 0 && $7d85f4634d55e2f9$var$isPunctuationChar(chars[chars.length - 1]))trailingPunctuation.unshift(chars.pop());
    if (trailingPunctuation.length === 0) return chars;
    if (chars.length > 0 && chars.length % boxesPerLine === 0) {
        const lastIndex = chars.length - 1;
        chars[lastIndex] = `${chars[lastIndex]}${trailingPunctuation.join("")}`;
        return chars;
    }
    return chars.concat(trailingPunctuation);
}
function $7d85f4634d55e2f9$var$getCharacterCount(text) {
    let count = 0;
    for (const char of text)if (/^[\p{L}\p{N}]$/u.test(char)) count++;
    return count;
}
function $7d85f4634d55e2f9$var$getRows(text, boxesPerLine) {
    const lines = text.length > 0 ? text.split(/\r?\n/) : [
        ""
    ];
    const rows = [];
    for (const line of lines){
        const cleanedLine = $7d85f4634d55e2f9$var$sanitizeInputText(line);
        const paragraphChars = $7d85f4634d55e2f9$var$applyParagraphRules(cleanedLine, boxesPerLine);
        if (paragraphChars.length === 0) {
            rows.push(Array.from({
                length: boxesPerLine
            }, ()=>""));
            continue;
        }
        for(let index = 0; index < paragraphChars.length; index += boxesPerLine){
            const cells = paragraphChars.slice(index, index + boxesPerLine);
            while(cells.length < boxesPerLine)cells.push("");
            rows.push(cells);
        }
    }
    return rows;
}
function $7d85f4634d55e2f9$var$updateCellSize() {
    const minCellSize = 12;
    const availableWidth = $7d85f4634d55e2f9$var$previewPanelElement.clientWidth;
    const columns = $7d85f4634d55e2f9$var$state.boxesPerLine;
    const widthPerCell = availableWidth / columns;
    const cellSize = Math.max(minCellSize, widthPerCell);
    $7d85f4634d55e2f9$var$previewElement.style.setProperty("--cell-size", `${cellSize}px`);
}
function $7d85f4634d55e2f9$var$render() {
    const rows = $7d85f4634d55e2f9$var$getRows($7d85f4634d55e2f9$var$state.text, $7d85f4634d55e2f9$var$state.boxesPerLine);
    const characterCount = $7d85f4634d55e2f9$var$getCharacterCount($7d85f4634d55e2f9$var$state.text);
    const rowCount = rows.length;
    const paragraphCount = $7d85f4634d55e2f9$var$state.text.length > 0 ? $7d85f4634d55e2f9$var$state.text.split(/\r?\n/).length : 1;
    $7d85f4634d55e2f9$var$updateCellSize();
    $7d85f4634d55e2f9$var$previewElement.replaceChildren();
    $7d85f4634d55e2f9$var$previewElement.style.setProperty("--boxes-per-line", String($7d85f4634d55e2f9$var$state.boxesPerLine));
    $7d85f4634d55e2f9$var$characterCountElement.textContent = `Character count: ${characterCount} | Rows: ${rowCount} | Paragraphs: ${paragraphCount}`;
    if (characterCount > $7d85f4634d55e2f9$var$PERFORMANCE_WARNING_THRESHOLD) {
        $7d85f4634d55e2f9$var$characterWarningElement.textContent = "Warning: performance may start to degrade above 1000 characters.";
        $7d85f4634d55e2f9$var$characterWarningElement.classList.remove("is-hidden");
    } else {
        $7d85f4634d55e2f9$var$characterWarningElement.textContent = "";
        $7d85f4634d55e2f9$var$characterWarningElement.classList.add("is-hidden");
    }
    const fragment = document.createDocumentFragment();
    for (const row of rows){
        const rowElement = document.createElement("div");
        rowElement.className = "row";
        for (const cellText of row){
            const cellElement = document.createElement("div");
            cellElement.className = "cell";
            cellElement.textContent = cellText;
            rowElement.appendChild(cellElement);
        }
        fragment.appendChild(rowElement);
    }
    $7d85f4634d55e2f9$var$previewElement.appendChild(fragment);
}
function $7d85f4634d55e2f9$var$updateText() {
    $7d85f4634d55e2f9$var$state.text = $7d85f4634d55e2f9$var$textareaElement.value;
    $7d85f4634d55e2f9$var$render();
}
function $7d85f4634d55e2f9$var$updateBoxesPerLine() {
    const nextValue = $7d85f4634d55e2f9$var$getValidBoxesPerLineInputValue();
    if (nextValue === null) return;
    $7d85f4634d55e2f9$var$state.boxesPerLine = nextValue;
    $7d85f4634d55e2f9$var$persistBoxesPerLine(nextValue);
    $7d85f4634d55e2f9$var$render();
}
function $7d85f4634d55e2f9$var$getValidBoxesPerLineInputValue() {
    const parsedValue = Number.parseInt($7d85f4634d55e2f9$var$boxesPerLineElement.value, 10);
    if (!Number.isFinite(parsedValue)) return null;
    if (parsedValue < $7d85f4634d55e2f9$var$MIN_BOXES_PER_LINE || parsedValue > $7d85f4634d55e2f9$var$MAX_BOXES_PER_LINE) return null;
    return parsedValue;
}
function $7d85f4634d55e2f9$var$resetBoxesPerLineInput() {
    $7d85f4634d55e2f9$var$boxesPerLineElement.value = String($7d85f4634d55e2f9$var$state.boxesPerLine);
}
function $7d85f4634d55e2f9$var$updatePreviewFont() {
    const nextFont = $7d85f4634d55e2f9$var$previewFontElement.value;
    $7d85f4634d55e2f9$var$state.previewFont = nextFont;
    $7d85f4634d55e2f9$var$persistPreviewFont(nextFont);
    $7d85f4634d55e2f9$var$applyPreviewFontClass(nextFont);
    $7d85f4634d55e2f9$var$render();
}
function $7d85f4634d55e2f9$var$clearPrintMode() {
    document.body.classList.remove("print-preview-only");
}
function $7d85f4634d55e2f9$var$printPreview() {
    document.body.classList.add("print-preview-only");
    window.print();
    // Fallback cleanup for browsers where afterprint is inconsistent.
    setTimeout(()=>{
        $7d85f4634d55e2f9$var$clearPrintMode();
    }, 300);
}
$7d85f4634d55e2f9$var$textareaElement.addEventListener("input", $7d85f4634d55e2f9$var$updateText);
$7d85f4634d55e2f9$var$boxesPerLineElement.addEventListener("input", $7d85f4634d55e2f9$var$updateBoxesPerLine);
$7d85f4634d55e2f9$var$boxesPerLineElement.addEventListener("blur", $7d85f4634d55e2f9$var$resetBoxesPerLineInput);
$7d85f4634d55e2f9$var$previewFontElement.addEventListener("change", $7d85f4634d55e2f9$var$updatePreviewFont);
$7d85f4634d55e2f9$var$printPreviewButtonElement.addEventListener("click", $7d85f4634d55e2f9$var$printPreview);
window.addEventListener("afterprint", $7d85f4634d55e2f9$var$clearPrintMode);
$7d85f4634d55e2f9$var$render();
$7d85f4634d55e2f9$var$previewElement.classList.remove("is-loading");
const $7d85f4634d55e2f9$var$resizeObserver = new ResizeObserver(()=>{
    $7d85f4634d55e2f9$var$render();
});
$7d85f4634d55e2f9$var$resizeObserver.observe($7d85f4634d55e2f9$var$previewPanelElement);


//# sourceMappingURL=japanese-composition-boxes.75fc96e0.js.map
